import React, {FunctionComponent} from "react";
import {Link} from "react-router-dom";
import {AlbumInfo} from "../models/responses";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faLock} from "@fortawesome/free-solid-svg-icons";

const AlbumList: FunctionComponent<{ albums: AlbumInfo[] }> = ({albums}) => {

    return (
        <div className="gallery-container">
            {albums.map((album, i) =>
                <div className="album" key={i}>
                    <Link key={"album" + i + album.thumbnail} to={"/album_viewer?link=" + album.access_code}>

                        <div><img src={album.thumbnail} title={album.name} alt={album.name}/></div>
                        <div className="album-name">
                            {album.locked && <><FontAwesomeIcon icon={faLock} />&nbsp;</>}
                            {album.name}
                        </div>
                    </Link>
                </div>
            )}
        </div>
    )
}

export default AlbumList